import { JooiceTheme } from 'src/theme/theme';

// ----------------------------------------------------------------------

export function skeleton(theme: JooiceTheme) {
  return {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.neutral,
        },
        rounded: {
          borderRadius: Number(theme.shape.borderRadius) * 2,
        },
      },
    },
  };
}
